import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, FormGroup, Modal, Button, FormControl, ControlLabel } from "react-bootstrap";
import moment from "moment";

const SystemLogDetailsModal = (props) =>  (
	<Modal className="dayoff-details-modal" show={props.showDetailsModal} onHide={props.handleClose}>
		<Modal.Header>
			<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={props.handleClose}>&times;</button>
			<Modal.Title>Log details</Modal.Title>
		</Modal.Header>
    
		<Modal.Body>
			<Row>
				<Col md={3} sm={4} xs={12}> <h4>User:</h4> </Col>   
				<Col md={9} sm={8} xs={12}> <h5>{props.selectedLog.user}</h5> </Col>  
			</Row>
			<Row>
				<Col md={3} sm={4} xs={12}>  <h4>Log type:</h4> </Col>   
				<Col md={9} sm={8} xs={12}>  <h5>{props.selectedLog.type}</h5> </Col>  
			</Row>
			<Row>
				<Col md={3} sm={4} xs={12}> <h4>Log create from:</h4> </Col>   
				<Col md={9} sm={8} xs={12}>  <h5>{props.selectedLog.from}</h5> </Col>  
			</Row>
			<Row>
				<Col md={3} sm={4} xs={12}>  <h4>Log description:</h4> </Col>   
				<Col md={9} sm={8} xs={12}>  <h5>{props.selectedLog.description}</h5> </Col>  
			</Row>
		</Modal.Body>
		<Modal.Footer>
			<Button bsStyle="default" className="btn-min" onClick={props.handleClose}>Close</Button>
		</Modal.Footer>
	</Modal>
);

SystemLogDetailsModal.defaultProps = {
	selectedLog: PropTypes.shape({
		user: "",
		from: "",
		type: "",
		description: "",
	})

};

SystemLogDetailsModal.propTypes = {
	showDetailsModal: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	selectedLog: PropTypes.shape({
		user: PropTypes.string,
		from: PropTypes.string,
		type: PropTypes.string,
		description: PropTypes.string,
	})
};

export default SystemLogDetailsModal;



// WEBPACK FOOTER //
// ./src/components/modals/SystemLogDetailsModal.js